@if (annotation) {
	<div class="c-annotation">
		<small class="icon-alert" [innerHTML]="annotation"> </small>
	</div>
}
